import axios from 'axios';

const baseURL =
  process.env.NODE_ENV === 'production'
    ? 'https://d-smart-staging.herokuapp.com/api'
    : 'http://localhost:5000/api';
const config = { baseURL, withCredentials: true };
const axiosInstance = axios.create(config);

axiosInstance.interceptors.response.use((res) => res.data);
export default axiosInstance;
